import React from 'react';
import { useGetVacancies } from '../data/queries';
import GeneralVacancies from './vacancies';

export default function VacanciesWrapper() {
  const { data: vacancies = [] } = useGetVacancies();
  return <GeneralVacancies items={vacancies} />;
}
